"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudSharedLocalEnvironment = void 0;
exports.CloudSharedLocalEnvironment = {
    apiUrl: "http://localhost:8080",
    applicationsProxyUrl: "localhost:4203",
    applicationsProxyIp: "127.0.0.1",
    applicationsPreviewUrlSuffix: "localhost",
    applicationsConnectUrl: "http://localhost:4206",
    checkinUrl: "http://localhost:4201",
    backofficeUrl: "http://localhost:8080"
};
